// extracted by mini-css-extract-plugin
export default {"button":"button--R2u7B","file":"file--anyWf"};